import apiTamboUrl from "@/services/api";

export default {
  namespaced: true,

  state: {
    reglas: [],
    historial: [],
    loading: false,
    loadingHistorial: false,
    error: null,
  },

  getters: {
    reglas: (s) => s.reglas,
    historial: (s) => s.historial,
    loading: (s) => s.loading,
    loadingHistorial: (s) => s.loadingHistorial,
    error: (s) => s.error,
  },

  mutations: {
    setReglas(state, data) {
      state.reglas = data;
    },
    setHistorial(state, data) {
      state.historial = data;
    },
    addRegla(state, r) {
      state.reglas.push(r);
    },
    updateRegla(state, updated) {
      const idx = state.reglas.findIndex((r) => r.id === updated.id);
      if (idx !== -1) state.reglas.splice(idx, 1, updated);
    },
    setLoading(state, val) {
      state.loading = val;
    },
    setLoadingHistorial(state, val) {
      state.loadingHistorial = val;
    },
    setError(state, val) {
      state.error = val;
    },
    clearState(state) {
      state.reglas = [];
      state.historial = [];
      state.loading = false;
      state.loadingHistorial = false;
      state.error = null;
    },
  },

  actions: {
    async fetchReglas({ commit }, soloActivas = false) {
      commit("setLoading", true);
      commit("setError", null);
      try {
        const qs = soloActivas ? "?solo_activas=true" : "";
        const res = await apiTamboUrl.get(`/retenciones/reglas${qs}`);
        commit("setReglas", res.data);
      } catch (e) {
        commit(
          "setError",
          e.response?.data?.detail || "Error al cargar reglas de retención"
        );
        throw e;
      } finally {
        commit("setLoading", false);
      }
    },

    async crearRegla({ commit }, payload) {
      const res = await apiTamboUrl.post("/retenciones/reglas", payload);
      commit("addRegla", res.data);
      return res.data;
    },

    async actualizarRegla({ commit }, { id, ...payload }) {
      const res = await apiTamboUrl.patch(`/retenciones/reglas/${id}`, payload);
      commit("updateRegla", res.data);
      return res.data;
    },

    async fetchHistorial({ commit }, params = {}) {
      commit("setLoadingHistorial", true);
      commit("setError", null);
      try {
        const qs = new URLSearchParams();
        if (params.periodo) qs.set("periodo", params.periodo);
        if (params.limit) qs.set("limit", String(params.limit));
        if (params.offset) qs.set("offset", String(params.offset));
        const qstr = qs.toString();
        const res = await apiTamboUrl.get(
          `/retenciones/historial${qstr ? "?" + qstr : ""}`
        );
        commit("setHistorial", res.data);
      } catch (e) {
        commit(
          "setError",
          e.response?.data?.detail || "Error al cargar historial de retenciones"
        );
        throw e;
      } finally {
        commit("setLoadingHistorial", false);
      }
    },
  },
};
